// One row of the translation grid. Three renderings share the class, chosen by cell
// template: the area header (MatrixGridHeaderCell), a transaction-code row
// (MatrixGridCodeCell — editable when a rule backs it), and a payment row
// (MatrixGridPaymentCell — read-only in this stage).
class MatrixGridCell extends UITableViewCell
{
    private nameLabel: MUILabel = null;
    private codeTextField: MUITextField = null;
    private codeLabel: MUILabel = null;
    private sourceLabel: MUILabel = null;

    awakeFromHTML() {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.codeLabel = MUIOutlet(this, "code-lbl", "MUILabel");
        this.sourceLabel = MUIOutlet(this, "source-lbl", "MUILabel");

        this.codeTextField = MUIOutlet(this, "code-tf", "MUITextField");
        if (this.codeTextField != null) {
            this.codeTextField.setOnChangeText(this, function(this:MatrixGridCell, tf:MUITextField, value:string) {
                if (this._rule == null) return;
                this._rule.value = value.trim();
            });
        }

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _rule: IntegratorMappingRule = null;

    setHeader(area: any) {
        let resolvers = (area["businessAreas"] ?? []).concat(area["cashDesks"] ?? []);
        this.nameLabel.text = area["revenueCenter"];
        if (this.sourceLabel != null) {
            this.sourceLabel.text = resolvers.length > 0 ? resolvers.join(", ") : MIOLocalizeString("UNREACHABLE", "UNREACHABLE — no business area or cashdesk");
        }
    }

    // A transaction cell: editable when a rule backs it — the input writes the rule row's
    // value directly, so Save persists it like any other edit. An empty cell shows as
    // missing; a legacy (targetUserInfo) cell shows its code read-only.
    setCode(entry: any) {
        let name = entry["category"];
        if (entry["default"] == true) name += " — " + MIOLocalizeString("DEFAULT", "default");
        if (entry["tips"] == true) name += " — " + MIOLocalizeString("TIPS", "tips");
        this.nameLabel.text = name;

        this._rule = null;
        let ruleID = entry["ruleID"];
        if (ruleID != null) {
            let predicate = MIOPredicate.predicateWithFormat("identifier == '" + ruleID + "'");
            this._rule = DBHelper.queryObjectFromMainContext("IntegratorMappingRule", predicate) as IntegratorMappingRule;
        }

        if (this.codeTextField != null) {
            this.codeTextField.text = entry["code"] ?? "";
            this.codeTextField.enabled = this._rule != null;
        }
        this.sourceLabel.text = this.sourceText(entry);
    }

    setPayment(entry: any) {
        this.nameLabel.text = entry["payMethod"];
        if (this.codeLabel != null) this.codeLabel.text = entry["roomCharge"] == true ? MIOLocalizeString("ROOM_CHARGE", "ROOM CHARGE") : (entry["code"] ?? "—");
        this.sourceLabel.text = this.sourceText(entry);
    }

    private sourceText(entry: any): string {
        if (entry["roomCharge"] == true) return MIOLocalizeString("POSTED_LIVE", "posted live");
        if (entry["empty"] == true) return MIOLocalizeString("MISSING_CODE", "MISSING — no code");
        let source = entry["source"];
        if (source == "rule") return MIOLocalizeString("RULE", "rule") + ": " + (entry["rule"] ?? "");
        if (source == "cell") return MIOLocalizeString("SEEDED_CELL", "seeded cell — edit via re-seed");
        return source ?? "";
    }
}
